/**
 * use-request-aggregates.ts
 *
 * Hook per recuperare gli aggregati delle richieste (counts per tipo, status, anno,
 * trend mensile, top clienti, tempi di completamento). Usato da pagine tipo per i contatori
 * e da analytics/statistics per popolare KPI e grafici.
 */

import { useQuery } from '@tanstack/react-query';
import { requestsNew } from '../services/api';
import { useCacheConfig } from '../contexts/cache-config-context';
import { RequestAggregatesQuery } from '../types/api';

export function useRequestAggregates(query?: RequestAggregatesQuery) {
  const { config } = useCacheConfig();

  return useQuery({
    queryKey: ['requests', 'aggregates', query],
    queryFn: () => requestsNew.getAggregates(query),
    staleTime: config.requests * 2,
    gcTime: config.requests * 4,
    placeholderData: (prev) => prev,
  });
}
